<template>
  <div class="block">
    <a href="#" :class="isLoad ? 'title open':'title'" @click.prevent="getItems">Сотрудничество с медиапартнерами</a>
    <transition name="fade">
      <div class="content" style="overflow: auto;" v-if="isLoad">
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>Наименование профильного учреждения</th>
            <th>Номер соглашения</th>
            <th>Копия договора (Титульная страница)</th>
            <th>Направление сотрудничества</th>
          </tr>
          </thead>
          <tbody v-if="items">
          <tr v-bind:key="item.id" v-for="item in items">
            <td>{{ item.name_org }}</td>
            <td>{{ item.contract }}</td>
            <td>
              <a v-if="item.copyContract" :href="item.copyContract" target="_blank">Файл</a>
            </td>
            <td>{{ item.direction }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </transition>
  </div>
</template>

<script>
import Axios from 'axios'

export default {
  name: "MediaCooperationPartner",
  data() {
    return {
      items: false,
      isLoad: false
    }
  },
  methods: {
    getItems() {
      if (!this.isLoad && !this.items) {
        this.isLoad = true
        const path = this.$store.state.api + this.$store.state.apiMediaCooperationPartner + "?eoId=" + this.$store.state.eoId
        const $this = this
        Axios({
          method: 'get',
          url: path
        }).then((response) => {
          if (
              response.status == 200
              && response.data.result == "success"
          ) {
            $this.items = response.data.data
            return $this.items
          }
        })
      } else {
        this.isLoad = !this.isLoad
      }
    }
  }
}
</script>

<style scoped>

</style>
